import AnnotationModel from './AnnotationModel';

export {
    AnnotationModel
};



// WEBPACK FOOTER //
// ./~/@girder/large_image_annotation/models/index.js